import styled, { css } from 'styled-components';
import Btn from 'components/atoms/Btn';

interface MoveButtonContainerProps {
    spacing?: number;
}

export const MoveButtonContainer = styled.div<MoveButtonContainerProps>`
    ${ props => props.spacing ? css`margin-top: ${props.spacing}px;` : null}
`;

export const MoveButtonWrapper = styled.div`
display: flex;
    justify-content: space-between;
`;

export const BtnPrev = styled(Btn)`
margin-right:8px;`;
export const BtnNext = styled(Btn)``;